require("./audio_upload_modal")
// Generates a table displaying all audio files

class AllAudio extends HTMLElement{
  constructor() {
    super();
  }
  connectedCallback() {
    this.innerHTML = `<div>
                        <div class="row">
                          <div class="col-sm-12" style="display:flex; justify-content: space-between; margin-bottom: 10px;">
                            <h3>Manage Audio</h3>
                            <a class="btn btn-primary" id="audio-modal-open">Upload Audio</a>
                          </div>  
                        </div>
                      </div>
                      
                      <table id="all_audio" class="table vertical-middle" style="width:100%">
                          <tfoot style="display: table-header-group;">
                              <tr>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                                  <th></th>
                              </tr>
                          </tfoot>
                          <thead>
                              <tr>
                                <th></th>
                                <th>Name</th>
                                <th>Audio</th>
                                <th>Audio Type</th>
                                <th>In Use</th>
                              </tr>
                          </thead>
                      </table>`;
    let audio_modal = document.createElement('audio-upload-modal');
    audio_modal.savedCallback = this.reloadData.bind(this);
    this.append(audio_modal);
    this.init();
  }
                    
  init() {
    this.table = $('#all_audio').DataTable({
      "ajax": "/admin/target_audio",
      "columns": [
        {
          "class": "details-control",
          "orderable": false,
          "data": null,
          "defaultContent": ""
        },
        { "data": "audio_desc" },
        {
          data: "audio_url",
          "render": function(data, type, row) {
            return `<audio-player src="${data}"></audio-player>`;
          },
          "class": "text-center"
        },
        {
          data: "target_audio_type.name",
          "class": "text-center"
        },
        {
          data: "is_used",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? '<span class="fa '+((data==true) ? "fa-check":"fa-times")+'"></span>' : data
          }, // feature
          "class": "text-center"
        }
      ],
      initComplete: function () {
        var column = this.api().column(3);
        var select = $('<select><option value="">All Types</option></select>')
            .prependTo( $(column.footer()).empty() )
            .on( 'change', function () {
                var val = $.fn.dataTable.util.escapeRegex(
                    $(this).val()
                );

                column
                    .search( val ? '^'+val+'$' : '', true, false )
                    .draw();
            } );

        column.data().unique().sort().each( function ( d, j ) {
            select.append( '<option value="'+d+'">'+d+'</option>' )
        });            
      },
      "order": [[1, 'asc']]
    });
    this.table.on('draw', function () {
      soundManager.reboot();
      $.each(detailRows, function (i, id) {
        $('#' + id + ' td.details-control').trigger('click');
      });
    });

    let detailRows = [];

    $('#all_audio tbody').on('click', 'tr td.details-control', async function (e) {
      let tr = $(e.target).closest('tr');
      let row = this.table.row(tr);
      let idx = $.inArray(tr.attr('id'), detailRows);

      if (row.child.isShown()) {
        tr.removeClass('details shown');
        row.child.hide();

        detailRows.splice(idx, 1);
      }
      else {
        let oldSelectedTr = $("table#all_audio tr.shown");
            if(oldSelectedTr.size() > 0) {
              let oldSelectedRow = this.table.row(oldSelectedTr);
              oldSelectedTr.next('tr').removeClass('details-row');
              oldSelectedRow.child.hide();
              oldSelectedTr.removeClass('shown');
            }
        tr.addClass('details shown');
        let row_detail = document.createElement("group-detail-row");
        row_detail.id = row.data().target_audio_id;

        // Get selected groups
        let groups = await fetch(`/admin/target_audio/${row_detail.id}/audio_groups`);
        let audio_ids = await groups.json();
        row_detail.current_selected_groups = audio_ids.map(group => group.group_id);

        row_detail.url = `/admin/target_audio/${row_detail.id}/audio_items`;
        row.child(row_detail).show();

        if (idx === -1) {
          detailRows.push(tr.attr('id'));
        }
      }
    }.bind(this));

    document.querySelector("#audio-modal-open").addEventListener("click", function() {
      $("#manageAudioModal").modal("show");
    });

    soundManager.setup({
      url: '/assets/swf/'
    });
  }

  reloadData() {
    this.table.ajax.reload();
  }
}

customElements.define("all-audio", AllAudio)